import React, { useState } from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"
import Lightbox from "react-image-lightbox"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Logo from "../components/logo"
import arts from "../data/arts.json"
import categories from "../data/categories.json"
import authors from "../data/authors.json"

import "react-image-lightbox/style.css"

const Title = styled.h2`
  margin-top: 40px;
`

const Images = styled.div`
  display: flex;
  flex-wrap: wrap;
`

const Art = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  width: 47%;
  margin-right: 20px;
  margin-bottom: 20px;

  @media only screen and (max-width: 736px) {
    width: 100%;
  }
`

const ArtTitle = styled.h4`
  display: flex;
  margin-bottom: 10px;
`

const Author = styled.h5`
  display: flex;
`

const Image = styled(Img)`
  width: 100%;
  margin-right: 100px;
  margin-bottom: 10px;
`

const ImageLink = styled.img`
  width: 100%;
  margin-right: 100px;
  margin-bottom: 10px;
`

function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

export default function Category({ pageContext: { category } }) {
  const dbCat = categories.find(cat => cat.link === category.link)
  const catId = dbCat ? dbCat.id : 1
  const data = useStaticQuery(graphql`
    query AllArtsQueryForCategory {
      allArtsJson {
        edges {
          node {
            id
            author
            authorName
            category
            name
            year
            link
            image {
              childImageSharp {
                fluid(
                  maxWidth: 800
                  quality: 75
                  base64Width: 60
                  jpegProgressive: true
                  cropFocus: ATTENTION
                  toFormat: JPG
                  srcSetBreakpoints: [480, 560, 768]
                  sizes: "(max-width: 768px) 500px, 90vw"
                  traceSVG: {
                    turnPolicy: TURNPOLICY_MINORITY
                    blackOnWhite: false
                    optCurve: true
                    turdSize: 7
                  }
                ) {
                  ...GatsbyImageSharpFluid_withWebp_tracedSVG
                }
              }
            }
          }
        }
      }
    }
  `)
  console.log("Arts are", data)
  const catArts = data.allArtsJson.edges.filter(
    artNode => artNode.node.category === catId
  )

  const [index, setIndex] = useState(0)
  const [isOpen, setIsOpen] = useState(false)
  const fullArray = catArts.map(artNode => {
    const art = artNode.node
    return art.image ? art.image.childImageSharp.fluid.src : ""
  })
  const captionsArray = catArts.map(artNode => {
    const art = artNode.node
    return art.name
  })

  const prevIndex = index - (1 % fullArray.length)
  const nextIndex = (index + fullArray.length + 1) % fullArray.length
  return (
    <Layout>
      <SEO title={"Исчезающая Калуга | " + category.title} />
      <Logo />
      {/* <Link to="/"> &#8592; На главную</Link> */}
      <Title>{category.title}</Title>
      <Images>
        {catArts.map((artNode, index) => {
          let art = artNode.node
          let author = authors.find(a => a.id === art.author)
          return (
            <Art
              key={art.id}
              onClick={() => {
                setIsOpen(true)
                setIndex(index)
              }}
            >
              {art.image && (
                <Image fluid={art.image.childImageSharp.fluid} alt={art.name} />
              )}
              {!art.image && <ImageLink src={art.link} alt={art.name} />}
              <ArtTitle>{art.name}</ArtTitle>
              <Link to={"/authors/" + author.id}>
                {author.id !== 22 && <Author>{author.name}</Author>}
                {author.id === 22 && <Author>{art.authorName}</Author>}
              </Link>
            </Art>
          )
        })}
      </Images>
      {/* <img src={pokemon.sprites.front_default} alt={pokemon.name} /> */}
      {/* <ul>
        {pokemon.abilities.map(ability => (
          <li key={ability.name}>
            <Link to={`./pokemon/${pokemon.name}/ability/${ability.name}`}>
              {ability.name}
            </Link>
          </li>
        ))}
      </ul> */}
      {isOpen && (
        <Lightbox
          mainSrc={fullArray[index]}
          nextSrc={fullArray[nextIndex]}
          prevSrc={fullArray[prevIndex]}
          imageCaption={captionsArray[index]}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() => setIndex(prevIndex)}
          onMoveNextRequest={() => setIndex(nextIndex)}
          imageLoadErrorMessage="Не удалось загрузить изображение"
          nextLabel="Следующее изображение"
          prevLabel="Предыдущее изображение"
          zoomInLabel="Приблизить"
          zoomOutLabel="Отдалить"
          closeLabel="Закрыть"
        />
      )}
    </Layout>
  )
}
